/* Eiken — instrumentation du menu (28/09/2026, lot 1 de la refonte du tiroir).
   Trois événements GA4 : menu_open, menu_expand, menu_click. Ils partent par le
   gtag que le canal Google de Shopify pose dans la page (G-9WLQTT6EFL, même
   client_id et même session que les page_view), vers GA4 seul depuis le
   02/10/2026. Sans consentement, gtag n'existe
   pas encore : l'événement est simplement ignoré. Chaque événement est aussi
   publié sur Shopify.analytics pour un éventuel pixel personnalisé.
   Paramètres : menu_surface (drawer | desktop), menu_label, menu_level (1..3),
   menu_url, menu_state (open | close). Aucune donnée personnelle. */
(function () {
  'use strict';

  // 02/10/2026 : envoi vers GA4 SEUL (send_to). Sans destination, gtag
  // l'envoyait aussi au remarketing Google Ads (AW-763264375). Et l'appel part
  // après l'image qui suit le clic : gtag coûte ~20 ms en synchrone (INP).
  function gaTarget() {
    var dl = window.dataLayer || [];
    for (var i = 0; i < dl.length; i++) {
      if (dl[i] && dl[i][0] === 'config' && /^G-/.test(dl[i][1])) return dl[i][1];
    }
    return null;
  }

  function send(name, params) {
    function go() {
      try {
        if (typeof window.gtag !== 'function') return;
        var p = Object.assign({ transport_type: 'beacon' }, params);
        var id = gaTarget();
        if (id) p.send_to = id;
        window.gtag('event', name, p);
      } catch (e) {}
    }
    var done = false;
    function once() { if (!done) { done = true; go(); } }
    if (document.visibilityState === 'hidden' || !window.requestAnimationFrame) once();
    else { requestAnimationFrame(function () { setTimeout(once, 0); }); setTimeout(once, 100); }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('eiken_' + name, params);
      }
    } catch (e) {}
  }

  function label(el) {
    var t = (el.getAttribute('data-menu-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
    return t.slice(0, 60);
  }

  // Niveau dans le tiroir : 1 + nombre d'ancêtres .mobile-nav__sublist (les
  // sous-listes sont imbriquées deux fois par niveau : wrapper + ul).
  function drawerLevel(el) {
    var n = 0, p = el.parentElement;
    while (p && p.id !== 'NavDrawer') {
      if (p.tagName === 'UL' && p.classList.contains('mobile-nav__sublist')) n++;
      if (p.tagName === 'UL' && p.classList.contains('mobile-nav__grandchildlist')) n++;
      p = p.parentElement;
    }
    return 1 + n;
  }

  // Niveau dans les panneaux coulissants : celui du panneau qui contient l'élément.
  function panelLevel(el) {
    var panel = el.closest('[data-nav-level]');
    return panel ? parseInt(panel.getAttribute('data-nav-level'), 10) || 1 : drawerLevel(el);
  }

  function desktopLevel(a) {
    if (a.classList.contains('site-nav__link')) return 1;
    if (a.closest('.site-nav__deep-dropdown')) return 3;
    return 2;
  }

  var globalBound = false;

  function init() {
    var drawer = document.getElementById('NavDrawer');
    if (drawer && drawer.getAttribute('data-eiken-events-ready') === '1') return;
    if (drawer) drawer.setAttribute('data-eiken-events-ready', '1');

    if (!globalBound) {
      globalBound = true;
      document.addEventListener('drawerOpen.NavDrawer', function () {
        send('menu_open', { menu_surface: 'drawer' });
      });
    }

    if (drawer) {
      // Phase de capture : on lit aria-expanded AVANT que le collapsible de
      // Motion (écouteur posé sur le bouton lui-même) ne le bascule.
      drawer.addEventListener('click', function (evt) {
        // Refonte 09/2026 : panneaux coulissants.
        var pushBtn = evt.target.closest('[data-nav-push]');
        if (pushBtn) {
          send('menu_expand', { menu_surface: 'drawer', menu_label: label(pushBtn), menu_level: panelLevel(pushBtn), menu_state: 'open' });
          return;
        }
        var backBtn = evt.target.closest('[data-nav-back]');
        if (backBtn) {
          var panel = backBtn.closest('[data-nav-panel]');
          var title = panel && panel.querySelector('.eiken-nav__panel-title');
          send('menu_expand', { menu_surface: 'drawer', menu_label: title ? label(title) : '', menu_level: panelLevel(backBtn) - 1, menu_state: 'close' });
          return;
        }
        // Accordéon Motion (version d'avant la refonte).
        var trigger = evt.target.closest('button.collapsible-trigger');
        if (trigger) {
          var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
          var labelEl = trigger.closest('.mobile-nav__has-sublist, .mobile-nav__child-item') || trigger;
          send('menu_expand', {
            menu_surface: 'drawer',
            menu_label: label(labelEl.querySelector('.mobile-nav__faux-link, .mobile-nav__link') || labelEl),
            menu_level: drawerLevel(trigger),
            menu_state: wasOpen ? 'close' : 'open'
          });
          return;
        }
        var link = evt.target.closest('a[href]');
        if (!link || link.getAttribute('href') === '#') return;
        send('menu_click', {
          menu_surface: 'drawer',
          menu_label: label(link),
          menu_level: panelLevel(link),
          menu_url: link.getAttribute('href')
        });
      }, true);
    }

    var header = document.getElementById('SiteHeader');
    if (header && header.getAttribute('data-eiken-events-ready') !== '1') {
      header.setAttribute('data-eiken-events-ready', '1');
      header.addEventListener('click', function (evt) {
        var link = evt.target.closest('a.site-nav__link, a.site-nav__dropdown-link');
        if (!link || link.getAttribute('href') === '#' || link.classList.contains('site-nav__link--icon')) return;
        send('menu_click', {
          menu_surface: 'desktop',
          menu_label: label(link),
          menu_level: desktopLevel(link),
          menu_url: link.getAttribute('href')
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Editeur de theme : la section En-tete est re-rendue, le tiroir aussi.
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector('#NavDrawer')) init();
  });
})();

/* Eiken — listes de produits (02/10/2026, lot 1 du suivi GA4).
   view_item_list quand une carte est vue (50 % visible, une fois par page) et
   select_item au clic, avec item_list_name = la rangée d'où vient le clic.
   GA4 rattache ensuite tout seul add_to_cart et purchase du même item_id à cette
   liste (rapports e-commerce « Nom de la liste d'articles »), sans dimension
   personnalisée. Condition : l'item_id doit être celui du canal Google,
   shopify_FR_<produit>_<variante>. « FR » est le pays de la boutique, pas celui
   du visiteur (vérifié le 02/10 depuis DE et US). Achat d'une AUTRE variante que
   celle de la carte = pas de rattachement.
   Envoi vers GA4 seul (send_to) : sans lui l'événement part aussi vers le
   remarketing Google Ads. Pages collection et recherche : clics seulement, le
   canal Google y envoie déjà view_item_list. Aucune donnée personnelle. */
(function () {
  'use strict';

  var ITEM_PREFIX = 'shopify_FR_';

  // Chemin sans préfixe de langue : /fr/pages/brands -> /pages/brands.
  function pagePath() {
    return location.pathname.replace(/^\/(fr|de|es|it|nl|pl|pt|sv)(?=\/|$)/, '') || '/';
  }

  // Id numérique de la collection, comme le canal Google : le handle de l'URL
  // est traduit (/fr/collections/sacs-a-dos-cuir), il couperait une même
  // collection en 9 lignes dans GA4.
  function collectionId() {
    var pg = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page;
    if (pg && pg.pageType === 'collection' && pg.resourceId) return String(pg.resourceId);
    var m = location.pathname.match(/\/collections\/([^/]+)/);
    return m ? m[1] : '';
  }

  // Ordre = priorité : une carte de recommandations est AUSSI dans un
  // data-section-type="collection-template", la règle la plus précise d'abord.
  var GRID = '.grid-product[data-product-id]';
  var LISTS = [
    { name: 'blog_prodgrid', sel: '.eiken-prodgrid', card: 'a.eiken-card', view: true,
      id: function (c) { return c.getAttribute('data-json') || ''; } },
    // item_list_id = groupe du test A/B de l'offre (cart-update.js, 20/10/2026).
    { name: 'cart_upsell', sel: '[data-cart-upsell]', card: null, view: true,
      id: function () { return 'ab_upsell_' + (document.documentElement.getAttribute('data-ab-upsell') || 'A'); } },
    { name: 'pairs_with', sel: '.cp', card: 'a.cp__link', view: true },
    { name: 'range_comparator', sel: '.rc-dialog', card: 'a.rc-card, a.rc-view', view: true },
    { name: 'bestsellers_rail', sel: '.eiken-bs-rail', card: GRID, view: true,
      id: function () { return pagePath(); } },
    { name: 'recently_viewed', sel: '.recently-viewed', card: GRID, view: true },
    { name: 'product_recommendations', sel: '[data-section-type="product-recommendations"]', card: GRID, view: true },
    { name: 'featured_collection', sel: '[data-section-type="featured-collection"]', card: GRID, view: true,
      id: function (c) { return c.getAttribute('data-section-id') || ''; } },
    { name: 'collection_switcher', sel: '[data-section-type="collection-switcher"]', card: GRID, view: true,
      id: function (c) { return c.getAttribute('data-section-id') || ''; } },
    // Outlet (25/10/2026) : grille maison (sections/outlet-grid.liquid), une carte par variante,
    // l'id produit est sur la pastille de couleur DANS la carte.
    { name: 'outlet', sel: '.outlet-grid__list', card: 'li.outlet-card', view: true,
      pid: function (card) { var x = card.querySelector('[data-product-id]'); return x && x.getAttribute('data-product-id'); },
      id: collectionId },
    // Collections de marque (sections/eiken-km-collection.liquid, clé « km_collection » des
    // templates collection.<marque>.json) : pas de data-section-type, on vise l'enveloppe de
    // section. Même nom que les collections ordinaires ; le canal Google envoie déjà les vues.
    { name: 'collection', sel: '[id^="shopify-section-"][id$="__km_collection"]', card: GRID, view: false,
      id: collectionId },
    { name: 'search', sel: '[data-section-type="collection-template"]', card: GRID, view: false,
      when: function () { return /\/search(\/|$)/.test(location.pathname); },
      id: function () { return 'search'; } },
    { name: 'collection', sel: '[data-section-type="collection-template"]', card: GRID, view: false,
      id: collectionId }
  ];

  var gaId = null;
  function gaTarget() {
    if (gaId) return gaId;
    var dl = window.dataLayer || [];
    for (var i = 0; i < dl.length; i++) {
      var e = dl[i];
      if (e && e[0] === 'config' && /^G-/.test(e[1])) { gaId = e[1]; break; }
    }
    return gaId;
  }

  // gtag arrive parfois après une rangée déjà visible au chargement : on garde
  // les événements 10 s au plus. Sans consentement gtag n'apparaît pas, la file
  // est alors abandonnée.
  var queue = [];
  var retries = 0;
  function drain() {
    if (typeof window.gtag !== 'function') {
      if (++retries <= 10) setTimeout(drain, 1000); else queue = [];
      return;
    }
    var id = gaTarget();
    queue.splice(0).forEach(function (ev) {
      try {
        var p = Object.assign({ transport_type: 'beacon' }, ev[1]);
        if (id) p.send_to = id;
        window.gtag('event', ev[0], p);
      } catch (e) {}
    });
  }
  // gtag prépare l'envoi de façon synchrone : ~20 ms au clic sur un mobile
  // ralenti (mesuré le 02/10). On lui passe la main APRÈS l'image qui suit le
  // clic, pour ne pas retarder la réaction de la page (INP). Le document vit
  // encore le temps que la page suivante réponde, et gtag vide sa file au
  // pagehide. Repli à 100 ms si requestAnimationFrame ne tourne pas.
  function later() {
    // Page masquée : pas d'image à attendre (requestAnimationFrame est suspendu).
    if (document.visibilityState === 'hidden') { drain(); return; }
    var done = false;
    function go() { if (!done) { done = true; drain(); } }
    if (window.requestAnimationFrame) requestAnimationFrame(function () { setTimeout(go, 0); });
    setTimeout(go, 100);
  }
  function send(name, params) {
    queue.push([name, params]);
    if (queue.length === 1) later();
  }

  function listOf(el) {
    for (var i = 0; i < LISTS.length; i++) {
      var L = LISTS[i];
      if (L.when && !L.when()) continue;
      var c = el.closest(L.sel);
      if (c) return { def: L, el: c };
    }
    return null;
  }

  function cardsOf(list) {
    return list.def.card ? list.el.querySelectorAll(list.def.card) : [list.el];
  }

  function text(root, sel) {
    var n = root.querySelector(sel);
    return n ? n.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function variantFromHref(a) {
    var href = a && a.getAttribute('href');
    var m = href && href.match(/[?&]variant=(\d+)/);
    return m ? m[1] : '';
  }

  // card = la carte entière ; link = l'ancre cliquée s'il y en a une (une
  // pastille couleur porte sa propre variante).
  function itemOf(card, list, link) {
    // Carte modèle invisible des recommandations Motion (le produit courant) et
    // colonne du produit courant dans le comparateur : ni vue ni clic utiles.
    if (card.closest('[aria-hidden="true"], .visually-invisible, [aria-current="true"]')) return null;
    // L'id se lit sur la carte elle-même, jamais sur un parent : sur une fiche
    // produit, un bloc parent porte l'id du produit OUVERT (mauvais produit).
    var pid = card.getAttribute('data-eg-pid') || card.getAttribute('data-product-id') ||
              (list.def.pid ? list.def.pid(card) : null);
    var main = card.matches('a') ? card : card.querySelector('a.grid-product__link, a.outlet-card__link');
    var vid = variantFromHref(link) || variantFromHref(main) ||
              card.getAttribute('data-eg-vid') || card.getAttribute('data-variant-id');
    if (!pid || !vid) return null;
    var pos = parseInt(card.getAttribute('data-eg-pos'), 10) ||
              Array.prototype.indexOf.call(cardsOf(list), card) + 1;
    var item = {
      item_id: ITEM_PREFIX + pid + '_' + vid,
      item_name: card.getAttribute('data-eg-name') || text(card, '.grid-product__title, .cp__name, .eiken-card__name, .rc-collabel'),
      index: pos,
      item_list_name: list.def.name,
      item_list_id: list.def.id ? list.def.id(list.el) : ''
    };
    var price = parseFloat(card.getAttribute('data-eg-price'));
    if (!isFinite(price)) price = parseInt(card.getAttribute('data-price-cents'), 10) / 100;
    if (isFinite(price)) item.price = price;
    return item;
  }

  function cardFrom(target, list) {
    var sel = list.def.card;
    return sel ? target.closest(sel) : list.el;
  }

  // ---- Clics ----
  function onClick(evt) {
    if (evt.type === 'auxclick' && evt.button !== 1) return;
    var t = evt.target;
    if (!t || !t.closest) return;
    var link = t.closest('a[href]');
    var add = t.closest('[data-upsell-add]');
    if (!add && !(link && /\/products\//.test(link.getAttribute('href')))) return;
    var list = listOf(t);
    if (!list) { if (link) storyLink(link); return; }
    var card = cardFrom(t, list);
    if (!card) return;
    var item = itemOf(card, list, link);
    if (!item) return;
    send('select_item', { item_list_name: item.item_list_name, item_list_id: item.item_list_id, items: [item] });
    remember(item, !!add);
  }

  /* Rattachement liste -> panier -> commande (04/10/2026). GA4 ne reporte PAS la liste d'un
     select_item sur l'add_to_cart du canal Google, qui arrive sur une autre page : 0 ajout
     rattaché sur 21 possibles (03-04/10). On le fait nous-mêmes :
     - au clic, la liste est mémorisée PAR PRODUIT pour la session (couvre l'achat d'une autre
       couleur que celle de la carte) ;
     - à l'ajout au panier de ce produit : événement list_add_to_cart (eiken_detail = liste,
       eiken_label = id de liste) ;
     - l'origine est écrite dans l'attribut de panier caché _eg_lists ({id produit: liste}), qui
       suit la commande dans Shopify (chiffre d'affaires par liste).
     Seulement avec le consentement mesure : rien n'est mémorisé ni écrit sinon. */
  var LKEY = 'eg_lists';
  var pendingUpsell = null;
  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) {}
    return typeof window.gtag === 'function';
  }
  function readLists() {
    try { return JSON.parse(sessionStorage.getItem(LKEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function remember(item, isUpsellAdd) {
    if (!consentOk()) return;
    var m = String(item.item_id).match(/^shopify_[A-Z]{2}_(\d+)_(\d+)$/);
    if (!m) return;
    var all = readLists();
    all[m[1]] = { n: item.item_list_name, i: item.item_list_id || '', t: Date.now() };
    try { sessionStorage.setItem(LKEY, JSON.stringify(all)); } catch (e) {}
    if (isUpsellAdd) pendingUpsell = { pid: m[1], vid: m[2], price: item.price, t: Date.now() };
  }
  /* Liens produits des récits (25/10/2026) : « Dans la gamme », séries, modèle équivalent,
     encart des collections de marque. Ce sont des liens simples, sans carte ni id produit :
     au clic on mémorise la liste par HANDLE (celui de l'URL, déjà dans la langue du visiteur),
     puis la fiche d'arrivée la reporte sur son id produit, et le rattachement panier ->
     commande (list_add_to_cart, _eg_lists) marche comme pour les autres rangées.
     item_list_id = le module d'origine (ks-serie, eps-models, kc-echo…). */
  var HKEY = 'eg_lists_h';
  var STORY_LINK = '.ks-mod, .eps-sec, .eps-dec, .eps-band, .eps-dark, .kc-echo, [id^="shopify-section-"][id$="__km_collection"]';
  function handleOf(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function storyLink(link) {
    var mod = link.closest(STORY_LINK);
    var h = handleOf(link.getAttribute('href'));
    if (!mod || !h) return;
    var key = (Array.prototype.find.call(mod.classList, function (c) {
      return /^(ks|eps|kc)-/.test(c) && !/^(ks-mod|ks-dark|eps-wrap|eps-sec)$/.test(c);
    }) || mod.classList[0] || 'story');
    send('select_item', { item_list_name: 'story_link', item_list_id: key, items: [{ item_name: h, item_list_name: 'story_link', item_list_id: key }] });
    if (!consentOk()) return;
    var all = {};
    try { all = JSON.parse(sessionStorage.getItem(HKEY) || '{}') || {}; } catch (e) {}
    all[h] = { n: 'story_link', i: key, t: Date.now() };
    try { sessionStorage.setItem(HKEY, JSON.stringify(all)); } catch (e) {}
  }
  // Sur la fiche d'arrivée : handle -> id produit.
  function adoptStoryLink() {
    var m = productMeta();
    if (!m || !consentOk()) return;
    var h = handleOf(location.pathname);
    var hs = {};
    try { hs = JSON.parse(sessionStorage.getItem(HKEY) || '{}') || {}; } catch (e) {}
    if (!h || !hs[h]) return;
    var all = readLists();
    all[String(m.product.id)] = hs[h];
    delete hs[h];
    try { sessionStorage.setItem(LKEY, JSON.stringify(all)); sessionStorage.setItem(HKEY, JSON.stringify(hs)); } catch (e) {}
  }

  function onAdded(evt) {
    if (!consentOk()) return;
    var line = evt.detail && evt.detail.product;
    var pid, vid, qty = 1, price;
    if (line && line.product_id) {
      pid = String(line.product_id); vid = String(line.variant_id); qty = line.quantity || 1;
      price = typeof line.final_price === 'number' ? line.final_price / 100 : undefined;
    } else if (pendingUpsell && Date.now() - pendingUpsell.t < 8000) {
      // Bouton « + » de la suggestion du panier : l'événement part sans détail.
      pid = pendingUpsell.pid; vid = pendingUpsell.vid; price = pendingUpsell.price;
    } else return;
    pendingUpsell = null;
    var origin = readLists()[pid];
    if (!origin) return;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined;
    var it = { item_id: ITEM_PREFIX + pid + '_' + vid, item_list_name: origin.n, item_list_id: origin.i, quantity: qty };
    if (price !== undefined) it.price = price;
    var p = { eiken_detail: origin.n, eiken_label: origin.i, variant_id: vid, items: [it] };
    if (price !== undefined && cur) { p.value = price * qty; p.currency = cur; }
    send('list_add_to_cart', p);
    tagCart(pid, origin);
  }
  // Attribut de panier caché (le « _ » le masque au checkout). Lu puis fusionné, 30 produits max.
  function tagCart(pid, origin) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var cur = {};
      try { cur = JSON.parse((cart.attributes && cart.attributes._eg_lists) || '{}') || {}; } catch (e) {}
      cur[pid] = origin.n + (origin.i ? '|' + origin.i : '');
      var keys = Object.keys(cur);
      if (keys.length > 30) keys.slice(0, keys.length - 30).forEach(function (k) { delete cur[k]; });
      return fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _eg_lists: JSON.stringify(cur) } })
      });
    }).catch(function () {});
  }

  // ---- Vues ----
  var seen = new Set();
  var watched = new WeakSet();
  var pending = new Map();
  var flushTimer = null;

  function flush() {
    flushTimer = null;
    pending.forEach(function (items, key) {
      send('view_item_list', { item_list_name: items[0].item_list_name, item_list_id: items[0].item_list_id, items: items });
    });
    pending.clear();
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var card = entry.target;
      io.unobserve(card);
      var list = listOf(card);
      if (!list) return;
      var item = itemOf(card, list, null);
      if (!item) return;
      var key = item.item_list_name + '|' + item.item_list_id;
      if (seen.has(key + '|' + item.item_id)) return;
      seen.add(key + '|' + item.item_id);
      if (!pending.has(key)) pending.set(key, []);
      pending.get(key).push(item);
      clearTimeout(flushTimer);
      flushTimer = setTimeout(flush, 1000);
    });
  }, { threshold: 0.5 }) : null;

  function scan() {
    scanTimer = null;
    if (!io) return;
    LISTS.forEach(function (L) {
      if (!L.view || (L.when && !L.when())) return;
      var containers = document.querySelectorAll(L.sel);
      for (var i = 0; i < containers.length; i++) {
        var cards = L.card ? containers[i].querySelectorAll(L.card) : [containers[i]];
        for (var j = 0; j < cards.length; j++) {
          if (watched.has(cards[j])) continue;
          watched.add(cards[j]);
          io.observe(cards[j]);
        }
      }
    });
  }

  // Les rangées arrivent souvent après coup (vus récemment, recommandations,
  // tiroir panier, grille du blog) : un seul observateur, scan regroupé.
  var scanTimer = null;
  function scheduleScan() {
    if (!scanTimer) scanTimer = setTimeout(scan, 400);
  }

  /* ===== Lots 2 et 3 (02/10/2026) : tiroir panier et fiche produit =====
     Paramètres communs, à déclarer UNE fois dans GA4 (Admin > Définitions
     personnalisées, portée Événement) : eiken_detail (la variante de l'action :
     open/close, in_stock/sold_out, 2/4/8…), eiken_label (libellé ou contexte),
     variant_id ; métrique shipping_gap (montant restant pour la livraison
     gratuite, devise du panier). Aucune donnée personnelle (jamais l'e-mail ni le
     texte d'embossage, seulement sa longueur). */
  function ev(name, detail, extra) {
    var p = Object.assign({}, extra);
    if (detail != null) p.eiken_detail = String(detail);
    send(name, p);
  }

  // ---- Panier ----
  var lastAdd = 0;
  var lastCart = null;

  // Ligne Redo (prime « retours gratuits », vendor re:do) : pas un article, hors des items GA4.
  function isRedoLine(l) { return String((l && l.vendor) || '').trim().toLowerCase() === 're:do'; }
  function cartItems(cart) {
    return (cart.items || []).filter(function (l) { return !isRedoLine(l); }).map(function (l, i) {
      return { item_id: ITEM_PREFIX + l.product_id + '_' + l.variant_id, item_name: l.product_title,
               price: l.final_price / 100, quantity: l.quantity, index: i + 1 };
    });
  }

  // Motion ouvre le tiroir DANS l'écouteur ajaxProduct:added, avant le nôtre :
  // on laisse la chaîne d'événements finir avant de dire si c'est un ajout.
  function onCartOpen() {
    setTimeout(function () {
      var trigger = Date.now() - lastAdd < 3000 ? 'add' : 'open';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          cartCount = cart.item_count;
          ev('view_cart', trigger, { currency: cart.currency, value: cart.total_price / 100, items: cartItems(cart) });
          if (cart.item_count === 0) ev('empty_cart_view', 'open');
        }).catch(function () {});
    }, 50);
  }

  /* ---- Panier vide du tiroir (05/10/2026) ----
     empty_cart_view : eiken_detail = open (tiroir ouvert sur un panier vide)
       | emptied (le dernier article vient d'être retiré, tiroir ouvert).
     empty_cart_click : eiken_detail = door (une des 4 portes)
       | recently_viewed (un sac de « vus récemment ») ; eiken_label = handle
       de la collection (data-eg-door, stable dans les 9 langues) ou du produit.
     Le retour arrière reste compté par cart_undo. Rien sur la page /cart. */
  var cartCount = null;
  function cartDrawerOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(d && d.classList.contains('drawer--is-open'));
  }
  // `cart:updated` porte le panier complet (theme.js) : aucune requête de plus.
  function onCartUpdated(e) {
    var c = e && e.detail && e.detail.cart;
    if (!c || typeof c.item_count !== 'number') return;
    if (cartCount > 0 && c.item_count === 0 && cartDrawerOpen()) ev('empty_cart_view', 'emptied');
    cartCount = c.item_count;
  }
  function onEmptyCartClick(a) {
    var door = a.hasAttribute('data-eg-door');
    var card = door ? null : a.closest('[data-product-handle]');
    var handle = door ? a.getAttribute('data-eg-door') : (card ? card.getAttribute('data-product-handle') : '');
    ev('empty_cart_click', door ? 'door' : 'recently_viewed', { eiken_label: handle || '' });
  }

  // État du compteur de livraison gratuite posé par cart-update.js (renderShipHint).
  /* redo_coverage (26/10/2026) : yes = « Commander avec Checkout+ », no = « Commander sans
     retours gratuits » (boutons Redo, événement eiken:redo-checkout de eiken-redo-style.liquid),
     none = notre bouton natif (Redo absent : il masque ce bouton quand il s'affiche). */
  function onCheckout(btn, coverage) {
    var hint = document.querySelector('[data-ship-hint]');
    var state = (hint && hint.dataset.egState) || 'none';
    var extra = { eiken_label: btn.closest('#CartDrawer') ? 'drawer' : 'cart_page', redo_coverage: coverage || 'none' };
    if (state === 'progress') extra.shipping_gap = (parseInt(hint.dataset.egRemaining, 10) || 0) / 100;
    if (lastCart) { extra.currency = lastCart.currency; extra.value = lastCart.total_price / 100; }
    ev('checkout_click', state, extra);
  }

  // ---- Fiche produit ----
  function productMeta() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return m && m.product ? m : null;
  }

  var lastVariant = null;
  var lastEmboss = 0;
  function onVariant(e) {
    var v = e.detail && e.detail.variant;
    var m = productMeta();
    if (!v || !v.id || !m) return;
    // Seulement le produit de la page (pas un aperçu rapide d'un autre produit).
    var mine = (m.product.variants || []).some(function (x) { return String(x.id) === String(v.id); });
    if (!mine || String(v.id) === lastVariant) return;
    lastVariant = String(v.id);
    // Le bouton d'embossage bascule une option Oui/Non cachée : ce n'est pas un
    // choix de couleur ou de taille, on ne le compte pas.
    if (Date.now() - lastEmboss < 1500) return;
    ev('variant_select', v.available ? 'in_stock' : 'sold_out', { variant_id: lastVariant });
  }

  function currentVariant() {
    var u = new URLSearchParams(location.search).get('variant');
    var m = productMeta();
    var input = document.querySelector('[data-section-type="product"] form.product-single__form [name="id"]');
    return lastVariant || u || (m && m.selectedVariantId ? String(m.selectedVariantId) : '') || (input ? String(input.value || '') : '');
  }

  function bisSubmit(root) {
    var email = root.querySelector('[data-bis-email]');
    var v = email ? (email.value || '').trim() : '';
    // Même garde que le formulaire : sans e-mail plausible, rien ne part.
    if (!v || v.indexOf('@') < 1) return;
    ev('restock_request', null, { variant_id: root.dataset.variant || currentVariant() });
  }

  function onUiClick(evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('button[name="checkout"]'))) return onCheckout(el);
    if ((el = t.closest('.drawer__undo-strip-btn, .eiken-empty__undo-btn'))) {
      return ev('cart_undo', el.classList.contains('drawer__undo-strip-btn') ? 'drawer' : 'empty_cart');
    }
    if ((el = t.closest('#CartDrawer .eiken-empty__door, #CartDrawer .eiken-empty__seen a[href]'))) {
      return onEmptyCartClick(el);
    }
    if (!productMeta()) return;
    if ((el = t.closest('[data-eiken-emboss-toggle]'))) {
      lastEmboss = Date.now();
      // Phase de capture : aria-expanded n'a pas encore basculé.
      return ev('emboss_toggle', el.getAttribute('aria-expanded') === 'true' ? 'close' : 'open', { variant_id: currentVariant() });
    }
    if ((el = t.closest('#MainContent .collapsible-trigger'))) {
      if (el.getAttribute('aria-expanded') === 'true') return;
      // Clé stable : id du bloc, sans le préfixe Motion ni l'id du produit.
      var key = (el.getAttribute('aria-controls') || '').replace(/^Product-content-/, '')
        .replace(String(productMeta().product.id), '');
      return ev('pdp_section_open', key, { eiken_label: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) });
    }
    if (t.closest('.jdgm-prev-badge')) return ev('reviews_click');
    if (t.closest('.rc-trigger')) return ev('compare_open');
    // « Voir la vidéo » (product-video-button.liquid), mesuré à partir du 21/10/2026 pour
    // décider de son emplacement (colonne d'achat ou galerie).
    if (t.closest('[data-pvb-open]')) return ev('video_open');
    if (t.closest('[data-bis-open]')) return ev('restock_open', null, { variant_id: currentVariant() });
    if ((el = t.closest('[data-bis-submit]'))) {
      var root = el.closest('[data-eiken-bis]');
      if (root) bisSubmit(root);
    }
  }

  function onKey(evt) {
    if (evt.key !== 'Enter' || !evt.target || !evt.target.matches || !evt.target.matches('[data-bis-email]')) return;
    var root = evt.target.closest('[data-eiken-bis]');
    if (root) bisSubmit(root);
  }

  // Ajout au panier avec embossage : le formulaire Motion part en AJAX depuis
  // son propre écouteur submit ; la capture au niveau document passe avant.
  function onSubmit(evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form.product-single__form')) return;
    var section = form.closest('[data-section-type="product"]') || document;
    var field = section.querySelector('.eiken-emboss-field__input');
    var text = field && field.offsetParent !== null ? (field.value || '').trim() : '';
    if (text) ev('emboss_add_to_cart', String(text.length), { variant_id: currentVariant() });
  }

  // Contenus atteints : un événement la 1re fois que le haut du bloc passe aux
  // 60 % de l'écran (marche aussi pour les blocs plus hauts que l'écran).
  function watchContent() {
    if (!('IntersectionObserver' in window)) return;
    // Description et icônes sont dans une AUTRE section que le bloc produit :
    // on cherche dans tout le contenu principal.
    var main = document.getElementById('MainContent') || document;
    var faqHeading = Array.prototype.find.call(main.querySelectorAll('.rte h2, .rte h3'),
      function (h) { return /^\s*FAQ/i.test(h.textContent); });
    // 25/10/2026 : schéma coté et FAQ des récits (.eps-specs__drawing, .ks-ech = le sac
    // dessiné à ses cotes, .eps-faq) comptent comme ceux des fiches classiques.
    var targets = [
      ['spec_icons', main.querySelector('.proposition-copy-box-prod')],
      ['specs', main.querySelector('.pdsp')],
      ['drawings', main.querySelector('.specimg, .eps-specs__drawing, .ks-ech')],
      ['faq', main.querySelector('section.faq, .eps-faq') || faqHeading],
      ['reviews', document.getElementById('judgeme_product_reviews')]
    ];
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        ev('pdp_content_view', e.target.getAttribute('data-eg-content'));
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    targets.forEach(function (t) {
      if (!t[1] || t[1].hasAttribute('data-eg-content')) return;
      t[1].setAttribute('data-eg-content', t[0]);
      obs.observe(t[1]);
    });
    watchStory(main);
  }

  /* Lecture des récits (25/10/2026) : sections/eiken-km-story.liquid (.ks-mod) et
     sections/eiken-product-story.liquid + snippets/eiken-story-modules.liquid (.eps-*).
     story_view : eiken_detail = module (ks-serie, eps-intro…), eiken_label = rang « 3/12 ».
     story_progress : eiken_detail = 25 | 50 | 75 | 100 (% des modules atteints, dans l'ordre
     de la page), eiken_label = ks | eps. Même règle que les blocs : le haut du module passe
     aux 60 % de l'écran. */
  function watchStory(main) {
    var SEL = 'section.ks-mod, section.eps-sec, section.eps-dec, section.eps-band, section.eps-dark';
    // Modules de premier niveau seulement (un module imbriqué compterait deux fois).
    var mods = Array.prototype.filter.call(main.querySelectorAll(SEL), function (s) {
      return !(s.parentElement && s.parentElement.closest(SEL));
    });
    var total = mods.length;
    if (total < 2) return;
    var kind = mods[0].classList.contains('ks-mod') ? 'ks' : 'eps';
    var reached = 0, sent = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        var rank = mods.indexOf(e.target) + 1;
        var key = Array.prototype.find.call(e.target.classList, function (c) {
          return /^(ks|eps)-/.test(c) && !/^(ks-mod|ks-dark|ks-open|eps-wrap|eps-sec|eps-dec|eps-band|eps-dark)$/.test(c);
        }) || (e.target.id || e.target.classList[0]);
        ev('story_view', key, { eiken_label: rank + '/' + total });
        if (rank > reached) reached = rank;
        [25, 50, 75, 100].forEach(function (p) {
          if (!sent[p] && reached / total * 100 >= p) { sent[p] = true; ev('story_progress', String(p), { eiken_label: kind }); }
        });
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    mods.forEach(function (s) { obs.observe(s); });
  }

  // Galerie (corrigé le 04/10/2026) : repères 2e, 4e, 8e photo DIFFÉRENTE affichée par le
  // visiteur. On compte la photo sélectionnée par Flickity (classe is-selected), pas la
  // visibilité : les fiches ont 25 à 38 photos (toutes les couleurs) et un choix de couleur
  // faisait défiler la galerie, chaque photo traversée comptait comme vue. La photo affichée
  // dans les 1,5 s qui suivent un choix de couleur ne compte pas (c'est la galerie qui saute).
  // Envoyés quand ils sont atteints, pas en quittant la page : un événement remis à gtag
  // pendant la fermeture n'arrive pas (testé le 02/10).
  function watchGallery() {
    var group = document.querySelector('[data-section-type="product"] [data-product-photos]');
    var slides = group ? Array.prototype.slice.call(group.querySelectorAll('.product-main-slide')) : [];
    var total = slides.length;
    if (total < 2 || !('MutationObserver' in window)) return;
    var seenSlides = new Set();
    var sent = {};
    var jumpAt = 0;
    document.addEventListener('variant:change', function () { jumpAt = Date.now(); });
    slides.forEach(function (s) { if (s.classList.contains('is-selected')) seenSlides.add(s); });
    if (!seenSlides.size) seenSlides.add(slides[0]);
    function count(s) {
      if (seenSlides.has(s) || Date.now() - jumpAt < 1500) return;
      seenSlides.add(s);
      var n = seenSlides.size;
      [2, 4, 8].forEach(function (m) {
        if (n >= m && !sent[m]) { sent[m] = true; ev('gallery_progress', String(m), { eiken_label: String(total) }); }
      });
    }
    var mo = new MutationObserver(function (records) {
      records.forEach(function (r) { if (r.target.classList.contains('is-selected')) count(r.target); });
    });
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
  }

  function start() {
    document.addEventListener('click', onClick, true);
    document.addEventListener('auxclick', onClick, true);
    document.addEventListener('click', onUiClick, true);
    document.addEventListener('eiken:redo-checkout', function (e) {
      var c = e.detail && e.detail.coverage;
      if (e.target && e.target.closest) onCheckout(e.target, c === 'yes' || c === 'no' ? c : 'none');
    });
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('ajaxProduct:added', function (evt) { lastAdd = Date.now(); onAdded(evt); });
    document.addEventListener('drawerOpen.CartDrawer', onCartOpen);
    document.addEventListener('cart:updated', onCartUpdated);
    if (productMeta()) {
      lastVariant = currentVariant() || null;
      adoptStoryLink();
      document.addEventListener('variant:change', onVariant);
      watchContent();
      watchGallery();
    }
    document.addEventListener('eiken:list-rendered', scheduleScan);
    if ('MutationObserver' in window) {
      new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
    }
    scan();
    // Vues en attente : on les envoie avant de quitter la page.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && pending.size) { clearTimeout(flushTimer); flush(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
